<template>
  <v-container>
    <v-row>
      <v-col
        v-for="(dict, index) in dictionary"
        :key="index"
        cols="12"
        md="12"
        class="pa-1"
      >
        <base-material-card
          :title="dict.description"
        >
          <v-card-title>
            <v-btn
              color="secondary"
              min-width="150"
              @click="changeDictionary(dict)"
            >
              Изменить поля
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :items="dict.data.filter(a=>a.enabled)"
              :headers="dict.keys.map((a, i)=>{return {value: 'data.' + a, text: dict.key_descriptions[i]}}).concat([{value: 'action', text: 'Действия'}])"
            >
              <template v-slot:item.action="{ item }">
                <v-icon

                  large
                  class="mr-2"
                  @click="show_change_dialog(dict,item)"
                >
                  mdi-cog
                </v-icon>
              </template>
            </v-data-table>
          </v-card-text>
          <div>
            <v-text-field
              v-for="(field, index) in dict.keys"
              :key="index"
              v-model="dict.new_data[field]"
              :label="dict.key_descriptions[index]"
            />
            <v-btn
              color="primary"
              min-width="200"
              @click="addData(dict.id, dict.new_data)"
            >
              Добавить запись
            </v-btn>
          </div>
        </base-material-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialog.change.show"
      max-width="600"
    >
      <base-material-card
        title="Изменить запись"
      >
        <v-text-field
          v-for="(field, index) in dialog.change.dict.keys"
          :key="index"
          v-model="dialog.change.item.data[field]"
          :label="dialog.change.dict.key_descriptions[index]"
        />
        <v-btn
          color="primary"
          min-width="200"
          @click="update_dictionary(dialog.change.dict.id, dialog.change.item)"
        >
          Сохранить
        </v-btn>
      </base-material-card>
    </v-dialog>
    <v-dialog
      v-model="dialog.dictionary.show"
      max-width="600"
    >
      <base-material-card
        title="Изменить словарь"
      >
        <v-col
          v-for="(item, index) in dialog.dictionary.keys"
          :key="index"
          cols="12"
        >
          <v-row
            style="max-width: 500px;"
          >
            <v-col cols="5">
              <v-text-field
                v-model="dialog.dictionary.keys[index]"
                color="secondary"
                label="Ключ"
              />
            </v-col>
            <v-col cols="5">
              <v-text-field
                v-model="dialog.dictionary.key_descriptions[index]"
                color="secondary"
                label="Описание"
              />
            </v-col>
            <v-col cols="1">
              <v-icon
                @click="dialog.dictionary.keys = dialog.dictionary.keys.filter((a, i)=>i!=index), dialog.dictionary.key_descriptions = dialog.dictionary.key_descriptions.filter((a, i)=>i!=index)"
              >
                mdi-delete
              </v-icon>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-icon
            @click="dialog.dictionary.keys.push(''),dialog.dictionary.key_descriptions.push('')"
          >
            mdi-plus
          </v-icon>
        </v-col>
        <v-col cols="12">
          <v-btn
            min-width="100"
            color="primary"
            @click="save_dictionary"
          >
            Сохранить
          </v-btn>
        </v-col>
      </base-material-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      form: {
        name: '',
      },
      dictionary: [],
      dialog: {
        dictionary: {
          id: '',
          show: false,
          keys: [],
          key_descriptions: [],
        },
        change: {
          dict: {},
          show: false,
          item: {},
        },
      },
    }),
    mounted: function () {
      this.load()
    },
    methods: {
      show_change_dialog: function (dict, item) {
        console.log(item)
        this.dialog.change.dict = dict
        this.dialog.change.item = item
        this.dialog.change.show = true
      },
      save_dictionary: function () {
        this.axios.post('/api/common/dictionary/save', this.dialog.dictionary)
          .then(response => {
            if (!response.data.error) {
              this.$store.commit('snackbar', 'Данные успешно обновление')
              this.load()
              this.dialog.dictionary.show = false
            } else {
              this.$store.commit('snackbar', 'Ошибка при обновлении данных')
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      },
      changeDictionary: function (item) {
        this.dialog.dictionary.id = item.id
        this.dialog.dictionary.show = true
        this.dialog.dictionary.keys = JSON.parse(JSON.stringify(item.keys))
        this.dialog.dictionary.key_descriptions = JSON.parse(JSON.stringify(item.key_descriptions))
      },
      update_dictionary (id, data) {
        this.axios.post('/api/common/dictionary/change', { id: id, data: data })
          .then(response => {
            if (!response.data.error) {
              this.$store.commit('snackbar', 'Данные успешно обновление')
              this.load()
              this.dialog.change.show = false
            } else {
              this.$store.commit('snackbar', 'Ошибка при обновлении данных')
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      },
      addData: function (id, data) {
        this.axios.post('/api/common/dictionary/add', { id: id, data: data })
          .then(response => {
            if (!response.data.error) {
              this.$store.commit('snackbar', 'Данные успешно обновление')
              this.load()
            } else {
              this.$store.commit('snackbar', 'Ошибка при обновлении данных')
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      },
      removeData: function (id, value) {
        this.axios.post('/api/common/dictionary/remove', { id: id, value: value })
          .then(response => {
            if (!response.data.error) {
              this.$store.commit('snackbar', 'Данные успешно обновление')
              this.load()
            } else {
              this.$store.commit('snackbar', 'Ошибка при обновлении данных')
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      },
      load: function () {
        this.axios.post('/api/common/dictionary/list')
          .then(response => {
            if (!response.data.error) {
              for (let x in response.data.data) {
                response.data.data[x].new_data = {}
              }
              this.dictionary = response.data.data
            } else {
              this.$store.commit('snackbar', 'Ошибка при получении данных')
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
      },
    },
  }
</script>

<style>

</style>
